<template>
  <div class="projection-slide text-center">
    <div class="big text-riseup-white">עוד {{ this.PERIOD }} שנה,</div>
    <div class="big text-riseup-white"> יכולים להיות לך</div>
    <div class="projected-amount text-riseup-white">{{ formattedProjectedAmount }} ₪ </div>
  </div>
</template>

<script>
import money from '@/utils/money';
import { INTEREST_RATE } from '@/constants/meitav-dash/open-fund';
import MoneyFormat from '@/mixins/MoneyFormat';

export default {
  name: 'ProjectionSlide',
  mixins: [MoneyFormat],
  props: {
    monthlyDepositSum: {
      type: Number,
      required: true,
    },
    oneTimeDepositSum: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    projectedAmount() {
      return money.compoundInterest(this.oneTimeDepositSum, this.monthlyDepositSum, INTEREST_RATE, this.PERIOD);
    },
    formattedProjectedAmount() {
      return this.formatAmountWithFraction(this.projectedAmount, 0);
    },
    PERIOD() {
      return 20;
    },

  },
};
</script>

<style scoped lang="scss">

.projection-slide {
  margin-top: 30px;
}

.big {
  font-size: 32px;
  font-family: SimplerPro_Alte-Black;
  line-height: normal;
}

.projected-amount {
  font-family: SimplerPro_Alte-Black;
  font-size: 60px;
  line-height: 1;
  margin-top: 120px
}

</style>
